import styled from 'styled-components'

export const StyledWorkScheduleItem = styled.div`
  background-color: ${props => props.color};
  border-radius: 4px;
  padding: 4px;
  width: 100%;
  margin: 0px;
`
